var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NodeViewWrapper',{staticClass:"callout",class:`callout--${_vm.type}`,attrs:{"data-text-el":"callout","as":"div"}},[_c(_vm.icon,{tag:"component",staticClass:"callout__icon"}),_vm._v(" "),_c('NodeViewContent',{staticClass:"callout__content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }